import React, { type FC } from 'react'
import { Button, IconButton, type SxProps, TableCell, TableRow, Typography } from '@mui/material'
import { type Notice } from '../../../redux/notices/notices-types'
import { DeleteNoticeAction } from '../../../redux/notices/notices-actions'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../redux/hooks'
import { formatEpochSecondsToTimestamp } from '../../../utils/utils'

const DELETE_PREVIEW_LENGTH = 20

interface Props {
  isAdmin: boolean
  notice: Notice
}

export const NoticeRow: FC<Props> = ({ isAdmin, notice }) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [expanded, setExpanded] = React.useState<boolean>(false)

  const lines = notice.content.split('\n')
  const createdAtValue: string = formatEpochSecondsToTimestamp(notice.createdAt)

  const onDeleteNotice = (): void => {
    const noticeStart = `${lines[0].substring(0, DELETE_PREVIEW_LENGTH)}`
    const previewText = noticeStart.length < lines[0].length ? `${noticeStart}...` : noticeStart
    const msg: string = t('notices.deleteConfirmation', { noticeStartText: previewText })
    if (window.confirm(msg)) {
      dispatch(DeleteNoticeAction(notice.id))
    }
  }

  const contentStyle: SxProps = expanded
    ? {}
    : {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: '1',
        WebkitBoxOrient: 'vertical'
      }

  return <TableRow>
        <TableCell>
            <Typography>{createdAtValue}</Typography>
        </TableCell>
        <TableCell>
            {lines.map((line, index) => {
              if (line === '') {
                return <br/>
              } else {
                return <Typography key={index} sx={contentStyle}>{line}</Typography>
              }
            })}
        </TableCell>
        <TableCell>
            <IconButton onClick={() => {
              setExpanded(!expanded)
            }}>
                {expanded
                  ? <ExpandLessIcon/>
                  : <ExpandMoreIcon/>
                }
            </IconButton>
        </TableCell>
        <TableCell>
            {isAdmin &&
              <Button
                variant='outlined'
                onClick={onDeleteNotice}
              >
                  {t('common.actions.delete')}
              </Button>
            }
        </TableCell>
    </TableRow>
}
